export default __webpack_public_path__ + "static/media/I10752.6c0dfd74.jpg";